import React from 'react';
import './Banner.css';

const Banner = () => {
    return (
        <div>
            <div className='main-container'>
                <div className='text-center name'>
                <h3>Lee Jong Suk </h3>
                <p>Actor; Model</p>
                </div>
                
            </div>
        </div>
    );
};

export default Banner;